
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 7h-4a1.5 1.5 0 01-1.5-1.5v-4A1.5 1.5 0 0110 0h4a1.5 1.5 0 011.5 1.5v4A1.5 1.5 0 0114 7zm-4-6a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4A.5.5 0 0014 1zm4 23h-4a1.5 1.5 0 01-1.5-1.5v-4A1.5 1.5 0 0110 17h4a1.5 1.5 0 011.5 1.5v4A1.5 1.5 0 0114 24zm-4-6a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5zm2-3.36a.5.5 0 01-.5-.5V9.5a.5.5 0 011 0v4.64a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M12 15a.5.5 0 01-.36-.15l-2-2.04a.5.5 0 01.72-.7L12 13.8l1.64-1.68a.5.5 0 01.72.7l-2 2.04A.5.5 0 0112 15z"}})])
          )
        }
      }
    